import { render, staticRenderFns } from "./ProductStockModal.vue?vue&type=template&id=3496cb46&scoped=true"
import script from "./ProductStockModal.vue?vue&type=script&lang=js"
export * from "./ProductStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496cb46",
  null
  
)

export default component.exports